import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04af2fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label mb-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "销售线索")
], -1))
const _hoisted_3 = { class: "card sales-leads-box mb-1" }
const _hoisted_4 = {
  class: "sales-leads-item",
  style: {"padding-bottom":"0","border-right":"1px solid #dde3ee"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "线索总数量", -1))
const _hoisted_6 = {
  class: "sales-leads-item",
  style: {"padding-bottom":"0"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "待跟进线索数", -1))
const _hoisted_8 = {
  class: "sales-leads-item",
  style: {"padding-bottom":"0","border-top":"1px solid #dde3ee","border-right":"1px solid #dde3ee"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "线索跟进及时率", -1))
const _hoisted_10 = {
  class: "sales-leads-item",
  style: {"padding-bottom":"0","border-top":"1px solid #dde3ee"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "线索转化率", -1))
const _hoisted_12 = {
  class: "card mb-1",
  style: {"padding":"12px 0"}
}
const _hoisted_13 = { class: "board-top-label mx-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "线索分布情况", -1))
const _hoisted_15 = { class: "card board-padding" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle" }, "线索跟进及时率")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board-top-label mb-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-title" }, "商机")
], -1))
const _hoisted_18 = { class: "grid-3 mb-1 text-white" }
const _hoisted_19 = { class: "sales-leads-item rounded bg1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "商机总数量", -1))
const _hoisted_21 = { style: {"color":"#fff"} }
const _hoisted_22 = { class: "sales-leads-item rounded bg2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "预计月销售额(万元)", -1))
const _hoisted_24 = { style: {"color":"#fff"} }
const _hoisted_25 = { class: "sales-leads-item rounded bg3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "实际月销售额(万元)", -1))
const _hoisted_27 = { style: {"color":"#fff"} }
const _hoisted_28 = { class: "grid-3 mb-1" }
const _hoisted_29 = { class: "card" }
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "grid-2" }
const _hoisted_33 = { class: "card" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mx-12 mb-1 pt-12" }, "商机状态分布情况", -1))
const _hoisted_35 = { class: "card" }
const _hoisted_36 = { class: "board-top-label mx-12 pt-12" }
const _hoisted_37 = { class: "from-box" }

import { ref, onMounted, toRef, watch, PropType } from 'vue'
import BoardPieChart from '../componects/BoardPieChart.vue'
import BoardLineChart from '../componects/BoardLineChart.vue'
import BoardFunnelChart from '../componects/BoardFunnelChart.vue'
import BoardGaugeChart from '../componects/BoardGaugeChart.vue'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'


const __default__ = { name: 'Tab1' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props

const clueDashboard = ref({
  clueTotal: 0,
  clueFollowingUp: 0,
  clueFollowingUpRate: '0%',
  clueConvertedRate: '0%'
})

const chanceDashboard = ref({
  chanceTotal: 0,
  planSaleAmountTotal: 0,
  monthActualSaleAmountTotal: 0
})
const followingUpRateList = ref([])
const chanceIncList = ref([])

const clueTypeValue = ref('1')
const chanceTypeValue = ref<number>(0)
const followingValue = ref<Dayjs>(dayjs())
const selectValue = ref<Dayjs>(dayjs())
const weakValues = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])

const formState = toRef(props, 'formState')

watch(
  () => props.formState,
  (newValue) => {
    formState.value = newValue
    fetchData()
  }
)


const chanceIncListParam = ref({
  dateQueryType: 3
})

const fetchClueTypeList = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/clue/dashboard', formState.value).then((res) => {
    clueDashboard.value = res.data
    clueDashboard.value.clueTypeListChartData = (res.data?.clueTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
    clueDashboard.value.clueChannelListChartData = (res.data?.clueChannelList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })

    clueDashboard.value.clueStateListChartData = [
      { name: '跟进中', value: res.data?.clueFollowingUp || 0 },
      { name: '已转化', value: res.data?.clueConverted || 0 }
    ]
  })
}
const fetchData = () => {
  fetchClueTypeList()

  fetchFollowing()

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/chance/dashboard', formState.value).then((res) => {
    chanceDashboard.value = res.data
    chanceDashboard.value.chanceConvertedRateChartData = [
      {
        name: '转化率',
        itemStyle: { color: '#12AEA5' },
        value: convertPercentageToNumber(res.data.chanceConvertedRate),
        tooltip: `已转化商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceConverted}</span><br>总商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceTotal}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceConvertedRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.saleAmountRateChartData = [
      {
        name: '销售额达成率',
        itemStyle: { color: '#1D4CD2' },
        value: convertPercentageToNumber(res.data.saleAmountRate),
        // value: 462564797.71,
        tooltip: `实际月销售额 <span style="font-weight: bolder;font-size: 16px">${res.data.monthActualSaleAmountTotal}</span><br>预计月销售额 <span style="font-weight: bolder;font-size: 16px">${res.data.planSaleAmountTotal}</span><br>达成率 <span style="font-weight: bolder;font-size: 16px">${res.data.saleAmountRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.chanceSuccessRateRateChartData = [
      {
        name: '完结率',
        itemStyle: { color: '#ff9a3e' },
        value: convertPercentageToNumber(res.data.chanceSuccessRate),
        // value: 70,
        tooltip: `已完结商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceSuccess}</span><br>总商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceTotal}</span><br>完结率 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceSuccessRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.chanceTypeListChartData = (res.data?.chanceTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
    chanceDashboard.value.orderTypeListChartData = (res.data?.orderTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })

    chanceDashboard.value.chanceStatusListChartData = (res.data?.chanceStatusList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
  })

  fetchIncList()
}

const fetchFollowing = () => {

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/region/clue/followingUpRateList', formState.value)
    .then((res) => {
      followingUpRateList.value = generateClueFollowingUpRateList(res.data?.clueFollowingUpRateList || [])
    })
}

const generateClueFollowingUpRateList = (clueFollowingUpRateList: any) => {
  const datas = []
  props.formState.region.deptScopeInfo.forEach((employee: any) => {
    const item = clueFollowingUpRateList.find((ii: any) => ii.employeeNo === employee.employeeNo)
    const quantity = item?.quantity || 0
    const total = item?.total || 0
    const rate = (total > 0 ? quantity / total : 0).toFixed(4)
    datas.push({
      name: `${employee.employeeName}`,
      value: rate,
      tooltip: `${props.formState.date.format('YYYY/MM')}<br>销售员：${employee.employeeName}<br>及时率 <span style="font-weight: bolder;font-size: 16px">${(
        rate * 100
      ).toFixed(2)}%</span>`
    })
  })
  return datas
}

const fetchIncList = () => {
  if (chanceIncListParam.value.dateQueryType === 3) {
    chanceIncListParam.value.startMonth = dayjs(selectValue.value).startOf('month').format('YYYY01')
    chanceIncListParam.value.endMonth = dayjs(selectValue.value).endOf('month').format('YYYY12')
  } else if (chanceIncListParam.value.dateQueryType === 2) {
    chanceIncListParam.value.startWeek = dayjs(weakValues.value[0]).format('YYYYww')
    chanceIncListParam.value.endWeek = dayjs(weakValues.value[1]).format('YYYYww')
  }

  if (chanceTypeValue.value === 0) {
    request
      .post<AxiosResult, AxiosResult>('/fbu/api/report/region/chance/incList', {
        ...formState.value,
        ...chanceIncListParam.value
      })
      .then((res) => {
        chanceIncList.value = generateIncList(res.data.chanceIncList || [])
      })
  } else {
    request
      .post<AxiosResult, AxiosResult>('/fbu/api/report/region/chance/convertedList', {
        ...formState.value,
        ...chanceIncListParam.value
      })
      .then((res) => {
        chanceIncList.value = generateChanceConvertedList(res.data?.chanceConvertedList || [])
      })
  }
}

const generateChanceConvertedList = (list: any) => {
  const datas = []

  if (chanceIncListParam.value.dateQueryType === 3) {
    const year = dayjs(selectValue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = (total > 0 ? quantity / total : 0).toFixed(4)
      datas.push({
        name: `${i}`,
        value: rate,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>转化商机 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总商机 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
    }
  } else {
    let currentDay = dayjs(weakValues.value[0])
    const lastDay = dayjs(weakValues.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = total > 0 ? quantity / total : 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: rate,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>转化商机 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总商机 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
      currentDay = currentDay.add(1, 'week')
    }
  }

  return datas
}

const generateIncList = (list: any) => {
  const datas = []

  if (chanceIncListParam.value.dateQueryType === 3) {
    const year = dayjs(selectValue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const quantity = item?.quantity || 0
      datas.push({
        name: `${i}`,
        value: quantity,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>新商机数 <span style="font-weight: bolder;font-size: 16px">${quantity}</span>`
      })
    }
  } else {
    let currentDay = dayjs(weakValues.value[0])
    const lastDay = dayjs(weakValues.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      // console.log('YYYY:', parseInt(currentDay.format('YYYYww'))
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      const quantity = item?.quantity || 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: quantity,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format('YYYY/MM/DD')}<br>新商机数 <span style="font-weight: bolder;font-size: 16px">${quantity}</span>`
      })
      currentDay = currentDay.add(1, 'week')
    }
  }

  return datas
}

function convertPercentageToNumber(percentageString: string): number {
  const noPercentage = percentageString.replace(/%/, '').replaceAll(',', '')
  return Number(noPercentage)
}


return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: 8,
          class: "text-subtitle"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", null, _toDisplayString(_unref(formatThousandSeparator)(clueDashboard.value.clueTotal)), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_unref(formatThousandSeparator)(clueDashboard.value.clueFollowingUp)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(clueDashboard.value.clueFollowingUpRate), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", null, _toDisplayString(clueDashboard.value.clueConvertedRate), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_a_select, {
                  value: clueTypeValue.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((clueTypeValue).value = $event)),
                  class: "from-box mr-12",
                  style: {"width":"100px"},
                  onChange: fetchClueTypeList
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("类型")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("来源")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("状态")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createVNode(BoardPieChart, {
                height: "230px",
                data: 
              clueTypeValue.value === '0'
                ? clueDashboard.value.clueTypeListChartData
                : clueTypeValue.value === '1'
                ? clueDashboard.value.clueChannelListChartData
                : clueDashboard.value.clueStateListChartData
            
              }, null, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(BoardLineChart, {
                height: "230px",
                data: followingUpRateList.value,
                isPercentageY: true
              }, null, 8, ["data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          span: 16,
          class: "text-subtitle"
        }, {
          default: _withCtx(() => [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatThousandSeparator)(chanceDashboard.value.chanceTotal)), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatThousandSeparator)(chanceDashboard.value.planSaleAmountTotal)), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(formatThousandSeparator)(chanceDashboard.value.monthActualSaleAmountTotal)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(BoardGaugeChart, {
                  height: "222px",
                  data: chanceDashboard.value.chanceConvertedRateChartData
                }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(BoardGaugeChart, {
                  height: "222px",
                  data: chanceDashboard.value.saleAmountRateChartData
                }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(BoardGaugeChart, {
                  height: "222px",
                  data: chanceDashboard.value.chanceSuccessRateRateChartData
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(BoardFunnelChart, {
                  height: "350px",
                  data: chanceDashboard.value.chanceStatusListChartData
                }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_a_radio_group, {
                    value: chanceTypeValue.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((chanceTypeValue).value = $event)),
                    onChange: fetchIncList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_button, { value: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("商机新增情况")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio_button, { value: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("商机转化情况")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createElementVNode("div", _hoisted_37, [
                    (chanceIncListParam.value.dateQueryType === 3)
                      ? (_openBlock(), _createBlock(_component_a_date_picker, {
                          key: 0,
                          value: selectValue.value,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectValue).value = $event)),
                          allowClear: false,
                          onChange: fetchIncList,
                          picker: "year"
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    (chanceIncListParam.value.dateQueryType === 2)
                      ? (_openBlock(), _createBlock(_component_a_range_picker, {
                          key: 1,
                          value: weakValues.value,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((weakValues).value = $event)),
                          allowClear: false,
                          picker: "week",
                          style: {"width":"220px"},
                          onChange: fetchIncList
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_radio_group, {
                      value: chanceIncListParam.value.dateQueryType,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((chanceIncListParam.value.dateQueryType) = $event)),
                      style: {"margin-left":"20px"},
                      onChange: fetchIncList
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_button, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("周")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio_button, { value: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode("月")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                _createVNode(BoardLineChart, {
                  height: "360px",
                  data: chanceIncList.value,
                  isPercentageY: chanceTypeValue.value === 1
                }, null, 8, ["data", "isPercentageY"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})